import type { Types } from '@ohif/core';
import { utils } from '@ohif/core';

const { sopClassDictionary: sop } = utils;

type DisplaySetWithSOPClassUID = Types.DisplaySet & {
  SOPClassUID?: string;
  instances?: Array<{ SOPClassUID?: string }>;
};

const DOWNLOADABLE_SOP_CLASS_UIDS = new Set<string>([
  sop.CTImageStorage,
  sop.EnhancedCTImageStorage,
  sop.LegacyConvertedEnhancedCTImageStorage,
  sop.SecondaryCaptureImageStorage,
  sop.MultiframeSingleBitSecondaryCaptureImageStorage,
  sop.MultiframeGrayscaleByteSecondaryCaptureImageStorage,
  sop.MultiframeGrayscaleWordSecondaryCaptureImageStorage,
  sop.MultiframeTrueColorSecondaryCaptureImageStorage,
]);

export function isDownloadableDisplaySet(
  displaySetInstanceUID: unknown,
  displaySetService: AppTypes.DisplaySetService
): boolean {
  if (typeof displaySetInstanceUID !== 'string') {
    return false;
  }
  const displaySet = displaySetService.getDisplaySetByUID(
    displaySetInstanceUID
  ) as DisplaySetWithSOPClassUID;
  if (!displaySet) {
    return false;
  }

  if (displaySet.Modality === 'RTSTRUCT' || displaySet.Modality === 'SR') {
    return true;
  }

  const sopClassUID = displaySet.SOPClassUID ?? displaySet.instances?.[0]?.SOPClassUID;

  return sopClassUID !== undefined && DOWNLOADABLE_SOP_CLASS_UIDS.has(sopClassUID);
}
